module.exports = __webpack_public_path__ + "941d6dd403a1577e3260c772687a4601.svg";